module.exports = __webpack_public_path__ + "img/omecon-tmp.feee3e0d.png";